<template>
	<BasicLayout>
		<div v-if="user.hasProfile(Profiles.USER) || user.hasProfile(Profiles.SYSTEM)">
			<h2>Derniers bilans reçus&nbsp;<el-link type="primary" href="#/checkups">voir tous&nbsp;<i class="fas fa-long-arrow-alt-right"></i></el-link></h2>
			<el-row :gutter="20" v-loading="victimsLoading">
				<el-col v-for="victim in victims" :key="victim.id" :md="6" :sm="12" :xs="24">
					<victim-card v-bind:victim="victim" />
				</el-col>
			</el-row>
			<el-divider></el-divider>
		</div>
		<el-row :gutter="40">

			<el-col :md="isCrraOrSdis ? 6 : 24" :sm="24" :xs="24">

				<el-row :gutter="20">

					<el-col :md="isCrraOrSdis ? 24 : 12" :sm="12" :xs="24">
						<h2>Votre compte&nbsp;<el-link type="primary" :href="'#/users/' + user.id">modifier&nbsp;<i class="fas fa-long-arrow-alt-right"></i></el-link></h2>
						<el-card class="account-card">
							<div><i class="fas fa-lg fa-fw fa-user"></i> {{user.name}}</div>
							<div><i class="fas fa-lg fa-fw fa-at"></i> {{user.mail}}</div>
							<div v-if="user.phone"><i class="fas fa-lg fa-fw fa-phone"></i> {{user.phone}}</div>
							<div><i class="fas fa-lg fa-fw fa-briefcase"></i> {{user.getProfilesNames().join(', ')}}</div>
						</el-card>
					</el-col>
					<el-col :md="isCrraOrSdis ? 24 : 12" :sm="12" :xs="24">
						<h2>Votre entité</h2>
						<el-card class="entity-card" v-loading="entityLoading">
							<div v-if="entity"><i class="fas fa-lg fa-fw fa-clinic-medical"></i> {{ entity.name }}</div>
							<div v-if="entity"><i class="fas fa-lg fa-fw fa-at"></i> {{ entity.email }}</div>
							<div v-if="entity"><i class="fas fa-lg fa-fw fa-map-marker-alt"></i> {{ entity.address }}</div>
						</el-card>
					</el-col>

				</el-row>

			</el-col>

			<el-col :md="18" :sm="24" :xs="24" v-if="isCrraOrSdis">
				<stats />
			</el-col>
		</el-row>
	</BasicLayout>
</template>

<script>
import BasicLayout from '@/layouts/basic.layout.vue'
import VictimCard from '@/components/victim.card.component.vue'
import Stats from '@/components/stats.component.vue'
import UserService from '@/services/user.service'
import EntityService from '@/services/entity.service'
import VictimService from '@/services/victim.service'
import Profiles from '@/constants/profiles.const'
import EntityTypes from '@/constants/entity.types.const'

export default {
	name: 'dashboard',
	components: { BasicLayout, VictimCard, Stats },
	data: function () {
		return {
			victims: null,
			victimsLoading: true,
			entity: null,
			entityLoading: true,
			Profiles: Profiles
		}
	},
	computed: {
		user: function() {
			return UserService.getCurrentUser()
		},
		isCrraOrSdis: function () {
			return EntityTypes.CRRA === this.user.entityType || EntityTypes.SDIS === this.user.entityType
		}
	},
	mounted: function() {

		// Récupère l'entité de l'utilisateur
		EntityService.getUserEntity(this.user.entityId).then((entity) => {
			this.entity = entity
			this.entityLoading = false
		})

		// Récupère les derniers bilans reçus
		if (this.user.hasProfile(Profiles.USER) || this.user.hasProfile(Profiles.SYSTEM)) {
			VictimService.getLastReceived().then((victims) => {
				this.victims = victims
				this.victimsLoading = false
			})
		}
	}
}
</script>

<style>

h2 .el-link {
	font-size: 12px;
	margin-left: 8px;
}

.account-card div:not(:last-child),
.entity-card div:not(:last-child) {
	margin-bottom: 8px;
}
.account-card div i,
.entity-card div i {
	margin-right: 8px;
}

.account-card, .entity-card {
	min-height: 136px;
}
</style>